// Extended features of Datapicker library

export default class UserDatapicker {

    customize() {
        const picker = document.querySelector('.react-date-picker__button__input');
        const inputMonth = document.querySelector('.react-date-picker__button__input__month');
        const inputYear = document.querySelector('.react-date-picker__button__input__year');
        const finalInput = document.querySelector('.react-date-picker__button__input input');

        if (!picker || !inputMonth) return;

        // Focus on click
        picker.onclick = () => {
            if (inputMonth.value.length < 1) {
                inputMonth.focus()
            }
        };

        if (!inputYear || !finalInput) return;

        // Set focus from month to year on input
        inputMonth.onkeyup = event => {
            const { value } = event.target;
            if (value.length >= 2 || value > 1) {
                finalInput.value = '2018-' + value;
                inputYear.focus();
            }
        };

        // Custom placeholders
        document.querySelector('.react-date-picker__button__input__month').placeholder = 'MM';
        document.querySelector('.react-date-picker__button__input__year').placeholder = 'YYYY';
    }

}


// WEBPACK FOOTER //
// ./src/classes/UserDatapicker.js